import { Events, Platform } from 'ionic-angular';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { ApiAuthLicenseKeyService } from './api-call-providers/api-auth-license-key.service';
import { COOKIES_CONFIG } from './../configs/cookies.config';
import { EVENTS_CONFIG } from './../configs/events.config';

@Injectable()
export class LicenseKeyService {

  licenseKey: string = "";

  constructor(
    private apiAuthLicenseKeyService: ApiAuthLicenseKeyService,
    private storage: Storage,
    private events: Events,
    private platform: Platform,
  ) {
  }

  /*
   * ライセンスキーの存在チェック
   * @return boolean
   */
  get hasLicenseKey(): boolean {
    return this.licenseKey.length > 0
  }

  /**
   * ライセンスキーを取得する
   * @return void
   */
  async getLicenseKey() {
    if (!this.licenseKey) {
      this.licenseKey = await this.storage.get(COOKIES_CONFIG.SYSTEM_TYPE) || ""
    }
    return this.licenseKey
  }

  /**
   * ライセンスキーをセットする
   * @return void
   */
  async setLicenseKey() {
    await this.storage.set(COOKIES_CONFIG.SYSTEM_TYPE, this.licenseKey)
  }

  /**
   * ライセンスキー認証
   * @return void
   */
  verify(licenseKey:string): void {

    // ライセンスキーのlocalデータを削除
    this.storage.remove(COOKIES_CONFIG.SYSTEM_TYPE);

    this.apiAuthLicenseKeyService.post(licenseKey).then((res) => {

      // Web版の場合は、ライセンス認証後、センサー情報が付与されているかチェックする
      // SJR大手門様の場合は、ビューワーのログイン画面に遷移する
      if (licenseKey === "WS7FGH6BYRM") {
        location.href = `https://app-viewer.cdc-iot.com/license?licenseKey?${licenseKey}`;
        return;
      }
      // センサー契約をシている場合、options = {sleep :{}} といったオブジェクトが返る
      if (res && res.options && Object.keys(res.options).length > 0) {
        // センサー契約をしている事業所であれば、そのまま利用
      } else if (location.origin !== "http://localhost:10032"){
        // そうでない場合は、既存のマニュアルページをDL可能にしておく
        location.href = `http://help.care-data-connect.com/u?licenseKey=${licenseKey}`;
        return;
      }
      // 認証に成功して初めてlicenseKeyをセットする。そうでないと認証失敗のライセンスキーを先に保持するのはバグの元かと...
      this.licenseKey = licenseKey;

      // リプレイス済みの法人であれば、リプレイス済み環境へ転送する
      const replacedApps = ["kan", "ffc"];
      if (res.isReplaced && replacedApps.find(a => a === res.applicationType)) {
        const oldDomains = ["https://my.care-data-connect.com", "https://my-v2.care-data-connect.com"];
        if (location.origin == "http://localhost:10032") {
          location.href = `http://localhost:10031/license?licenseKey=${licenseKey}`;
          return;
        } else if (oldDomains.find(d => d === location.origin)){
          location.href = `https://my-${res.applicationType}.cdc-iot.com/license?licenseKey=${licenseKey}`;
          return;
        }
      }
      // ライセンスキーをstorageに保存
      this.setLicenseKey().then(() => {

        // ライセンスキー認証完了イベントを発火
        this.events.publish(EVENTS_CONFIG.AUTH_LICENSE_KEY, res)
        this.events.publish(EVENTS_CONFIG.LICENSE_KEY, this.licenseKey)
        // URLセット
        this.events.publish(EVENTS_CONFIG.API_URL, res.apiUrl)
      })

    })
  }

}



// WEBPACK FOOTER //
// ./src/providers/license-key.service.ts